import { render } from "./ApplyKeywordsIcon.vue?vue&type=template&id=753cacbc"
import script from "./ApplyKeywordsIcon.vue?vue&type=script&lang=js"
export * from "./ApplyKeywordsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__